import { error as errorReducer } from './Error.reducer';

const defaultState = {
    showInfo: false,
};

export const exportMenu = (state = defaultState, action) => {
    const { type } = action;
    switch (type) {
        default:
            return state;
    }
}